<!-- LOADING SPINNER -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-[100] backdrop-blur-sm bg-white/30 no-print">
  <i class="fas fa-spinner fa-spin text-6xl text-[#006269]"></i>
</div>

<div class="h-screen overflow-y-auto bg-gray-200 custom-scrollbar print:bg-white print:h-auto print:overflow-visible">

  <!-- A4 Container -->
  <div id="print-section" class="a4-container font-sans print:m-0 print:shadow-none print:w-full">
    
    <!-- Outer Blue Border Container -->
    <div class="outer-border-container bg-white border-[6px] border-[#006269] p-6 print:p-8 flex flex-col h-full box-border" [style.borderColor]="customizeData?.colors?.outerBorder">

      <!-- Inner Black Border Container -->
      <div class="inner-print-container border border-black flex flex-col justify-between bg-white overflow-hidden h-full box-border">
        
        <!-- TOP SECTION -->
        <div class="flex-grow">
          <!-- Header Strip -->
          <div class="flex justify-between items-center px-6 py-2 border border-black bg-white">
            <div *ngIf="customizeData?.header?.gstin?.visible" class="text-[16px] font-bold text-[#006269]" [style.color]="customizeData?.header?.gstin?.color">{{ customizeData?.header?.gstin?.text || 'GSTIN: 06ACEFM7839B1Z9'}}</div>
            <div *ngIf="customizeData?.header?.taxInvoice?.visible" class="uppercase tracking-widest text-[12px] font-bold text-gray-600" [style.color]="customizeData?.header?.taxInvoice?.color">{{ customizeData?.header?.taxInvoice?.text || 'Tax Invoice'}}</div>
          </div>

          <!-- Branding -->
          <div class="relative px-8 py-6 border-b border-black text-center">
            <div class="absolute left-8 top-6" *ngIf="customizeData?.header?.logo?.visible">
              <img [src]="customizeData?.header?.logo?.url || 'assets/images/rate-list/rate-list3.png'" alt="Logo" class="h-24 w-24 object-contain"/>
            </div>
            <h1 *ngIf="customizeData?.header?.firmTitle?.visible" class="text-3xl font-bold text-[#006269] mb-1 uppercase tracking-tight" [style.color]="customizeData?.header?.firmTitle?.color">{{ customizeData?.header?.firmTitle?.text || 'Meena Silver & Co'}}</h1>
            <p *ngIf="customizeData?.header?.address?.visible" class="text-[13px] text-gray-600 font-medium" [style.color]="customizeData?.header?.address?.color">{{ customizeData?.header?.address?.text || 'Ground floor, 199, Warn No 11, Masjid Wali Gali, Rania, Sirsa, Haryana'}}</p>
            <div class="flex justify-center gap-6 mt-1 font-bold text-gray-800 text-[14px]">
              <p *ngIf="customizeData?.header?.pan?.visible" class="text-green">{{ customizeData?.header?.pan?.text || 'PAN: ACEFM7839B'}}</p> |
              <p *ngIf="customizeData?.header?.mobile?.visible">{{ customizeData?.header?.mobile?.text || 'Mob: 86838 36136'}}</p>
            </div>
          </div>

          <!-- Party details -->
          <div class="grid grid-cols-2 border-b border-black">
            <div class="border-r border-black p-6 px-8 min-h-[140px]">
              <h2 *ngIf="customizeData?.detailsLabels?.partyDetails?.visible" class="italic font-bold underline text-[13px] mb-2 text-[#333333]" [style.color]="customizeData?.detailsLabels?.partyDetails?.color">{{ customizeData?.detailsLabels?.partyDetails?.text || 'Party Details'}} :</h2>
              <div class="font-bold text-lg uppercase mb-2 text-[#006269]" [style.color]="customizeData?.colors?.themeColor">{{ invoiceData?.customer_name}}</div>
              <div class="text-[14px] space-y-1">
                  <p><span *ngIf="customizeData?.detailsLabels?.customerAddress?.visible" class="font-bold text-[#333333]">{{ customizeData?.detailsLabels?.customerAddress?.text || 'Address'}} : </span>{{ invoiceData?.customer_address }}</p>
                  <p *ngIf="invoiceData?.customer_gstin"><span class="font-bold text-[#333333]" [style.color]="customizeData?.detailsLabels?.gstinUin?.color">{{ customizeData?.detailsLabels?.gstinUin?.text || 'GSTIN / UIN'}} :</span> {{ invoiceData?.customer_gstin}} </p>
              </div>
            </div>

            <div class="p-6 px-8 text-[14px]">
              <div class="grid grid-cols-[150px_1fr] gap-y-1">
                <strong *ngIf="customizeData?.detailsLabels?.invoiceNo?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.invoiceNo?.color">{{ customizeData?.detailsLabels?.invoiceNo?.text || 'Invoice No.' }}</strong> <span>: {{ invoiceData?.invoice_no}}</span>
                <strong *ngIf="customizeData?.detailsLabels?.dated?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.dated?.color">{{ customizeData?.detailsLabels?.dated?.text || 'Dated' }}</strong> <span>: {{ invoiceData?.created_at | date:'dd - MMM - yyyy' }}</span>
                <strong *ngIf="customizeData?.detailsLabels?.modeOfPay?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.modeOfPay?.color">{{ customizeData?.detailsLabels?.modeOfPay?.text || 'Mode of Pay' }}</strong> <span>: {{ invoiceData?.payment_mode}}</span>
                <strong *ngIf="invoiceData?.customer_pan" class="text-[#333333]">Party PAN</strong> <span *ngIf="invoiceData?.customer_pan" class="uppercase">: {{ invoiceData?.customer_pan}}</span>
                <strong *ngIf="customizeData?.detailsLabels?.partyMobile?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.partyMobile?.color">{{ customizeData?.detailsLabels?.partyMobile?.text || 'Party Mobile' }}</strong> <span>: {{ invoiceData?.customer_mobile }}</span>
                <strong *ngIf="customizeData?.detailsLabels?.reverseCharge?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.reverseCharge?.color">{{ customizeData?.detailsLabels?.reverseCharge?.text || 'Reverse Charge' }}</strong> <span>: No</span>
                <strong *ngIf="customizeData?.detailsLabels?.placeOfSupply?.visible" class="text-[#333333]" [style.color]="customizeData?.detailsLabels?.placeOfSupply?.color">{{ customizeData?.detailsLabels?.placeOfSupply?.text || 'Place of supply' }}</strong> <span>: {{ invoiceData?.supply_place }}</span>
              </div>
            </div>
          </div>

          <!-- Table -->
          <table class="w-full border-collapse text-[13px]">
            <thead class="bg-[#006269] bg-teal-print text-white" [style.background]="customizeData?.colors?.themeColor">
              <tr>
                <th class="border-r border-white/20 p-2 w-12 text-center">{{ customizeData?.table?.headers?.[0]?.text || 'S.N.' }}</th>
                <th class="border-r border-white/20 p-2 text-left px-4 italic">{{ customizeData?.table?.headers?.[1]?.text || 'Description of Item'}}</th>
                <th class="border-r border-white/20 p-2 w-24 text-center">{{ customizeData?.table?.headers?.[2]?.text || 'HSN Code'}}</th>
                <th class="border-r border-white/20 p-2 w-28 text-center">{{ customizeData?.table?.headers?.[3]?.text || 'Quantity/ Gm'}}</th>
                <th class="border-r border-white/20 p-2 w-24 text-center">{{ customizeData?.table?.headers?.[4]?.text || 'Rate/Gram'}}</th>
                <th class="p-2 w-32 text-right px-6">{{ customizeData?.table?.headers?.[5]?.text || 'Amount(₹)'}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="h-12 align-middle border-b border-gray-200">
                <td class="border-r border-black text-center">1.</td>
                <td class="border-r border-black px-4 font-semibold italic">Silver Ornaments</td>
                <td class="border-r border-black text-center">711311</td>
                <td class="border-r border-black text-center font-bold text-lg">{{ invoiceData?.quantity_per_gm }}</td>
                <td class="border-r border-black text-center">{{ invoiceData?.rate_per_gm }}</td>
                <td class="p-2 text-right font-bold text-gray-900 px-6">{{ invoiceData?.amount | number:'1.2-2' }}</td>
              </tr>
              <tr class="h-12 align-middle border-b border-gray-200">
                <td class="border-r border-black text-center"></td>
                <td class="border-r border-black px-4 font-semibold italic"></td>
                <td class="border-r border-black text-center"></td>
                <td class="border-r border-black text-center font-bold text-lg"></td>
                <td class="border-r border-black text-center"></td>
                <td class="p-2 text-right font-bold text-gray-900 px-6"></td>
              </tr>
            </tbody>
            <tfoot class="border-t border-black text-[14px]">
              <tr>
                <td colspan="5" class="border-r border-black text-right px-6 font-semibold uppercase text-gray-600 py-2" [style.color]="customizeData?.summary?.taxableAmount?.color">{{ customizeData?.summary?.taxableAmount?.text || 'Taxable Amount'}}</td>
                <td class="p-2 text-right font-bold text-gray-800 px-6">₹ {{ invoiceData?.amount | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="invoiceData?.igst_amount > 0" class="border-t border-gray-200">
                <td colspan="5" class="border-r border-black text-right px-6 font-medium italic text-gray-500 py-2">IGST &#64; 3 %</td>
                <td class="p-2 text-right font-semibold text-gray-800 px-6">{{ invoiceData?.igst_amount }}</td>
              </tr>
              <ng-container *ngIf="!invoiceData?.igst_amount || invoiceData?.igst_amount <= 0">
                <tr class="border-t border-gray-200">
                  <td colspan="5" class="border-r border-black text-right px-6 font-medium italic text-gray-500 py-2">CGST &#64; 1.5 %</td>
                  <td class="p-2 text-right font-semibold text-gray-800 px-6">{{ invoiceData?.cgst_amount }}</td>
                </tr>
                <tr class="border-t border-gray-200">
                  <td colspan="5" class="border-r border-black text-right px-6 font-medium italic text-gray-500 py-2">SGST &#64; 1.5 %</td>
                  <td class="p-2 text-right font-semibold text-gray-800 px-6">{{ invoiceData?.sgst_amount }}</td>
                </tr>
              </ng-container>
              <tr class="border border-black bg-gray-50">
                <td colspan="5" class="border-r border-black text-right px-6 font-bold uppercase text-[#333333] py-2" [style.color]="customizeData?.summary?.total?.color">{{ customizeData?.summary?.total?.text || 'Sub Total'}}</td>
                <td class="p-2 text-right font-bold text-gray-900 px-6">₹ {{ invoiceData?.sub_total }}</td>
              </tr>
              <tr class="border-t border-gray-200">
                <td colspan="5" class="border-r border-black text-right px-6 font-medium text-gray-500 py-2" [style.color]="customizeData?.summary?.adjustment?.color">{{ customizeData?.summary?.adjustment?.text || 'Adjustment (Round Off)'}}</td>
                <td class="p-2 text-right text-green-600 font-bold px-6">+ {{ - invoiceData?.discount }}</td>
              </tr>
              <tr class="border-t-2 border-black" [style.backgroundColor]="customizeData?.summary?.grandTotal?.backgroundColor">
                <td colspan="5" class="text-right px-6 text-xl font-black uppercase py-3" 
                    [style.color]="customizeData?.summary?.grandTotal?.color">
                    {{ customizeData?.summary?.grandTotal?.text || 'Grand Total'}}
                </td>
                <td class="p-2 text-right text-2xl font-black px-6 whitespace-nowrap" 
                    [style.color]="customizeData?.summary?.grandTotal?.color">
                    ₹ {{ invoiceData?.grand_total }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- BOTTOM SECTION -->
        <div class="mt-4">
          <div class="grid grid-cols-2 border-t border-black">
            <!-- Footer -> Terms Section -->
            <div class="border-r border-black p-6 px-8 text-[11px] leading-tight text-gray-600">
              <h4 *ngIf="customizeData?.footer?.termsTitle?.visible" 
                  class="font-bold underline mb-1 uppercase" 
                  [style.color]="customizeData?.footer?.termsTitle?.color">
                  {{ customizeData?.footer?.termsTitle?.text || 'Terms And Conditions'}}
              </h4>

              <ul class="list-none space-y-0.5 text-black">
                <li *ngFor="let term of customizeData?.footer?.termsList">
                  <span *ngIf="term.visible">{{ term.text }}</span>
                </li>
              </ul>
            </div>
            <div class="flex flex-col justify-between p-6 px-8 text-center min-h-[100px]">
              <p *ngIf="customizeData?.footer?.forFirm?.visible" class="font-bold text-[14px] text-[#006269]" [style.color]="customizeData?.footer?.forFirm?.color">{{ customizeData?.footer?.forFirm?.text || 'For Meena Silver & Co.'}}</p>
              <div class="mt-6 flex flex-col items-center">

                <!-- SIGNATURE IMAGE -->
                <img
                  *ngIf="customizeData?.footer?.signature?.visible && customizeData?.footer?.signature?.url"
                  [src]="customizeData.footer.signature.url"
                  alt="Signature"
                  class="h-16 object-contain mb-2 print:block"
                />

                <!-- SIGNATORY TEXT -->
                <p
                  *ngIf="customizeData?.footer?.signatory?.visible"
                  class="border-t border-dotted border-gray-400 pt-1 font-bold text-[12px] uppercase"
                  [style.color]="customizeData?.footer?.signatory?.color">
                  {{ customizeData?.footer?.signatory?.text || 'AUTHORIZED SIGNATORY' }}
                </p>
              
              </div>

            </div>
          </div>
          <div class="bg-[#006269] bg-teal-print text-white p-3 text-center text-[13px] font-bold tracking-wide uppercase" [style.background]="customizeData?.colors?.themeColor" [style.color]="customizeData?.footer?.bankInfo?.color">
            {{ customizeData?.footer?.bankInfo?.text || 'Bank: HDFC Bank, Rania A/C: 50200116332671, IFSC: HDFC0002327'}}
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-center pb-10 no-print mt-4 mb-10">
  <button
    (click)="printInvoice()"
    class="group capitalize w-[200px] p-3 text-lg font-bold
           bg-[#006269] text-white rounded-md shadow-lg
           hover:bg-white hover:text-[#006269] hover:border
           transition-all mr-4 flex items-center justify-center gap-2">
      <i class="fas fa-print text-white text-[25px] group-hover:text-[#006269] transition-all"></i>
      Invoice
    </button>


  <button
    (click)="sendInvoiceWhatsapp()"
    class="group capitalize w-[200px] p-3 text-lg font-bold bg-white text-green-500
           rounded-md shadow-lg border transition-all
           hover:bg-green-500 hover:text-white flex items-center justify-center gap-2">
           <i class="fab fa-whatsapp text-green-500 text-[25px] group-hover:text-white transition-all"></i>
    WhatsApp
  </button>
</div>
</div>